import { api } from "@/lib/api";
import type { UsageAnalytics } from "@/types/admin";

export interface UsageAnalyticsFilters {
	startDate?: string;
	endDate?: string;
	userId?: string;
	projectId?: string;
	groupBy?: "day" | "week" | "month";
}

// Usage Analytics API Service
export const usageService = {
	// Get usage analytics
	getUsageAnalytics: async (
		filters?: UsageAnalyticsFilters,
	): Promise<UsageAnalytics> => {
		const response = await api.get<UsageAnalytics>("/admin/usage", filters);
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch usage analytics");
		}
		return response.data.data as UsageAnalytics;
	},
};
